module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-跳转20.44d77.png";